import gaService from "@/api/services/ga.service";
import {
  Button,
  Divider,
  Popover,
  PopoverVirtualElement,
  TextField,
} from "@mui/material";
import { useSnackbar } from "notistack";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import AddLinkIcon from "@mui/icons-material/AddLink";
import DataCard from "./dataCard";
const SharePopOver = (props: {
  isOpen: boolean;
  anchorEl:
    | Element
    | (() => Element)
    | PopoverVirtualElement
    | (() => PopoverVirtualElement)
    | null
    | undefined;
  onClose:
    | ((event: Event, reason: "backdropClick" | "escapeKeyDown") => void)
    | undefined;
}) => {
  // Use typeof window to ensure code only runs on client side
  const shareText =
    typeof window !== "undefined"
      ? `Hey, \n
    🚀 Just stumbled upon this awesome e-commerce trend platform!\n 📈 Check it out for the latest industry insights and trends: ${window.location.href}`
      : "";
  const { enqueueSnackbar } = useSnackbar();
  return (
    <Popover
      open={props.isOpen}
      anchorEl={props.anchorEl}
      onClose={props.onClose}
      anchorOrigin={{
        vertical: -100,
        horizontal: "right",
      }}
      sx={{
        margin: "5px",
        "& .MuiPaper-root": {
          borderRadius: "16px",
        },
      }}
      elevation={10}
    >
      <DataCard>
        <div className="p-3">
          <h2 className=" font-bold text-center text-slate-500 mb-2">Share</h2>
          <Divider />
          <p className="text-xs mt-3 p-2">Share this link via</p>
          <div className="p-2">
            <WhatsappShareButton
              url={shareText}
              onClick={(e) => {
                gaService.shareNowWA();
                props.onClose?.((e as unknown) as Event, "backdropClick");
              }}
            >
              <IconForShare name="whatsapp" />
            </WhatsappShareButton>
            <LinkedinShareButton
              url={window.location.href}
              onClick={(e) => {
                gaService.shareNowLI();
                props.onClose?.((e as unknown) as Event, "backdropClick");
              }}
            >
              <IconForShare name="linkedIn" />
            </LinkedinShareButton>
            <TwitterShareButton
              url={shareText}
              onClick={(e) => {
                gaService.shareNowX();
                props.onClose?.((e as unknown) as Event, "backdropClick");
              }}
            >
              <IconForShare name="twitter" />
            </TwitterShareButton>
            <FacebookShareButton
              url={window.location.href}
              hashtag="#ShiprocketTrends"
              onClick={(e) => {
                gaService.shareNowFB();
                props.onClose?.((e as unknown) as Event, "backdropClick");
              }}
            >
              <IconForShare name="facebook" />
            </FacebookShareButton>

            <div className=" mt-5">
              <p className=" mt-7 mb-3 text-xs  text-slate-500">Copy Link</p>
              <TextField
                value={window.location.href}
                variant="outlined"
                sx={{
                  width: "100%",
                }}
                onChange={() => {}}
              />

              <Button
                sx={{
                  backgroundColor: "#745BE7",
                  color: "white",
                  width: "100%",
                  marginTop: "10px",
                  "&:hover": {
                    backgroundColor: "#745BE7",
                    color: "white",
                  },
                }}
                onClick={(e) => {
                  gaService.shareNowCopyLink();
                  navigator.clipboard.writeText(window.location.href);
                  enqueueSnackbar("Copied to clipboard");
                  props.onClose?.(e as unknown as Event, "backdropClick")
                }}
              >
                Copy
              </Button>
            </div>
          </div>
        </div>
      </DataCard>
    </Popover>
  );
};

type IconForShareProps = {
  name: "whatsapp" | "facebook" | "twitter" | "linkedIn" | "clipboard";
  onClick?: VoidFunction;
};

const IconForShare: React.FC<IconForShareProps> = (props) => {
  const commonProps = {
    fontSize: "40px",
  };

  const icons = {
    whatsapp: (
      <WhatsAppIcon
        sx={{
          color: "#25D366",
          ...commonProps,
        }}
      />
    ),
    facebook: (
      <FacebookIcon
        sx={{
          color: "#316FF6",
          ...commonProps,
        }}
      />
    ),
    twitter: <XIcon sx={{ ...commonProps }} />,
    linkedIn: (
      <LinkedInIcon
        sx={{
          color: "#0A66C2",
          ...commonProps,
        }}
      />
    ),
    clipboard: (
      <AddLinkIcon
        sx={{
          ...commonProps,
        }}
      />
    ),
  };
  const names = {
    whatsapp: "Whatsapp",
    facebook: "Facebook",
    twitter: "X",
    linkedIn: "LinkedIn",
    clipboard: "Copy to clipboard",
  };

  return (
    <div className="flex flex-col justify-center items-center w-20">
      <span>
        {icons[props.name]}
        <p className="text-sm text-slate-500">{names[props.name]}</p>
      </span>
    </div>
  );
};

export default SharePopOver;
